import http from '@core/fetch'

export default {
  // 使用激活码
  useCdKey: body =>
    http.post('/p/wedding/Admin/APIMerchantPro/useCdKey', {
      body,
      onError: false
    }),
  // 通知详情获取对应激活码
  cdKeyDetail: body =>
    http('/p/wedding/Mainadmin/APINotification/cdKeyDetail', {
      body
    })
}
